import {getMethod, postMethod, putMethod} from '~/api'

async function get(hotelId, request) {
    return await getMethod(`/api/hotelDescription/${hotelId}/roomType`, request)
}

async function post(hotelId, request) {
    return await postMethod(`/api/hotelDescription/${hotelId}/roomType`, request)
}

async function put(hotelId, roomTypeId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/roomType/${roomTypeId}`, request)
}

export {get, post, put}
